export function generateRandomPassword() {
  const passowrd = Math.random().toString(36).substring(2, 8);
  return passowrd;
}
